
import { Component, Vue, Prop, Emit } from "vue-property-decorator"
import { CaseDetails } from "@/types"
import { Format } from "@/types/format"
import moment from "moment"
import formatApi from "@/services/api/Formatting"
import vSelect from "vue-select"
import { Getter } from "vuex-class"
import { RenderType, RenderTypes } from "@/types/renderTypes"

	@Component({
		components: {
			"v-select": vSelect
		}
	})

export default class AttachPrintTemplate extends Vue {
	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;
	@Prop({ required: true }) private currentCase!: CaseDetails;
	private formatTemplates: Format[] = [];
	private renderTypesList: RenderType[] = RenderTypes;
	private selectedFormat: Format | null = null;
	private downloading: boolean = false;
	private selectedRenderType: RenderType | null = null;

	private async mounted (): Promise<void> {
		await this.getFormatTemplates()
	}

	private async getFormatTemplates (): Promise<void> {
		const formats = await formatApi.formatGet()
		this.formatTemplates = formats.filter(f => f.templateId === this.currentCase.templateId)
	}

	private get isFormatSelected () : boolean {
		return this.selectedFormat != null
	}

	private emitFormatAndRenderType () : void {
		this.$emit("templateSettingsSet", this.selectedFormat, this.selectedRenderType)
	}

	private get previewFileTitle (): string {
		const currentDate = moment().format("YYYY-MM-DD")
		const caseName = this.currentCase.isCase ? this.getCaseName : this.getRecordName
		return `${caseName}-${this.currentCase.caseNumber} - ${this.selectedFormat?.title} - ${currentDate}`
	}

	private async onPreviewClick () : Promise<void> {
		if (this.isFormatSelected) {
			await formatApi.downloadPdf(this.previewFileTitle, this.currentCase.caseNumber!, this.selectedFormat!)
			this.$bvModal.hide("downloadPdfTemplateModal")
		}
	}
}
